module.exports = __webpack_public_path__ + "static/media/healthdiet.ae0b085f.jpg";